module.exports = __webpack_public_path__ + "img/aboutCompanyBg.40707559.svg";